import { render, staticRenderFns } from "./ShareToEditList.vue?vue&type=template&id=256be65e&scoped=true&"
import script from "./ShareToEditList.vue?vue&type=script&lang=js&"
export * from "./ShareToEditList.vue?vue&type=script&lang=js&"
import style0 from "./ShareToEditList.vue?vue&type=style&index=0&id=256be65e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256be65e",
  null
  
)

export default component.exports